<template>
    <div class="main-container">
        <HeaderElement />

        <div class="section-space--pt_200">
            <div class="container_fl">
                <div v-if="product" class="row">
                    <div class="col-lg-4">
                        <div class="text-center wow move-up">
                            <img class="shop-product__img" :src="product.img" alt="about">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <h3 class="shop-product__title">
                            MHP-Finance Paket "{{ product.package }}"
                        </h3>
                        <div class="shop-product__price">
                            <span class="shop-product__price-tag">
                                {{ formatPrice }}
                            </span>
                            <small class="shop-product__price-tax">inkl. MwSt. & Versand</small>
                        </div>

                        <router-link :to="{ name: 'HomeBranding', query: { product: product.package } }">
                            <button class="shop-product__btn ht-btn ht-btn-md">Produkt-Kauf Anfragen</button>
                        </router-link>

                        <div v-for="(block, index) in product.description" :key="index">

                            <h5 v-if="block.type === 'title'"
                                class="font-weight--light text-black section-space--mb_20 wow move-up">
                                {{ block.text }}
                            </h5>

                            <div v-else-if="block.type === 'text'" class="sub-text wow move-up section-space--mb_20">
                                {{ block.text }}
                            </div>

                            <div v-else-if="block.type === 'bold-text'"
                                class="sub-text wow move-up font-weight--bolder section-space--mb_20">
                                {{ block.text }}
                            </div>

                            <ul v-else-if="block.type === 'list'"
                                class="shop-product__list section-space--mb_20 wow move-up">
                                <li v-for="(item, i) in block.items" :key="i">
                                    - {{ item }}
                                </li>
                            </ul>

                            <h6 v-else-if="block.type === 'link'" class="text-black wow move-up">
                                <router-link :to="{ name: 'HomeBranding', query: { product: product.package } }"
                                    class="hover-style-link hover-style-link--green">
                                    {{ block.text }}
                                </router-link>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <FooterMain />
        <OffCanvasMobileMenu />
    </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import FooterMain from '@/components/FooterMain'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

export default {
    name: 'ShopProduct',
    components: {
        HeaderElement,
        FooterMain,
        OffCanvasMobileMenu
    },
    data() {
        return {
            product: null
        }
    },
    computed: {
        formatPrice() {
            if (!this.product) return '';
            return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2
            }).format(this.product.price) + ' EUR';
        }
    },
    async mounted() {
        try {
            const response = await fetch('/products.json');
            if (!response.ok) throw new Error('Fehler beim Laden der Produktdaten');
            const products = await response.json();
            this.product = products.find((item) => this.$route.params.package === item.package)
        } catch (error) {
            console.error('Fehler beim Laden der products.json:', error);
        }

    },
}
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;

.shop-product {
    &__img {
        width: 100%;
        border: 2px solid #978e8e;
        border-radius: .5rem;
        box-shadow: -1px 3px 12px 0px rgba(15, 15, 15, 0.1);
        margin-bottom: 1rem;
    }

    &__list {
        &>li {
            margin-bottom: .5rem;
            font-size: 1rem;
        }
    }

    &__title {
        margin-bottom: 1rem;
    }

    &__price {
        margin-bottom: 1rem;

        &-tag {
            font-size: 1.5rem;
        }

        &-tax {
            font-size: 1rem;
            color: #000;
        }
    }

    &__btn {
        margin-bottom: 2rem;
    }
}

@media #{vars.$tablet-up} {
    .shop-product {
        margin-top: 1rem;
        margin-bottom: 0;
    }
}

@media #{vars.$xlmax-up} {
    .shop-product {
        &__img {
            max-height: 500px;
            width: auto;
        }
    }
}
</style>
